export default {
  loading: 'Loading...',
  fetching: 'Fetching...',
  cloning: 'Cloning...',
  deleting: 'Deleting...',
  info: {
    publish_to_youtube: 'Wie will email you once your video has been published!'
  },
  error: {
    default: 'Sorry something went wrong while processing the request',
    missing_sign_up_token: 'Invalid sign up token',
    signup_failed: 'Sorry! We are unable to sign up',
    login_failed: 'Sorry! We are unable to login',
    incognito_login:
      'For google authentication to work, you need to enable third party cookies for the domain “accounts.google.com”. You can enable them in Settings → Site Settings → Cookies',
    unauthorized_login:
      'Sorry! you are not authorized to access this workspace',
    account_not_found:
      "Sorry! It seems you don't have an account in Trainn. Please sign up to continue.",
    workspace_not_found:
      'You do not have active workspace in Trainn. Please sign up to continue.',
    invalid_password: 'Incorrect password',
    invalid_old_password: 'Incorrect old password',
    clone_video_failed: 'Your video cloning has failed',
    download_transcript_failed: 'Downloading transcript has failed',
    download_video_failed: 'Downloading video has failed',
    upload_csv_failed: 'Uploading learners csv has failed'
  },
  success: {
    edit_theme: 'Theme edited successfully',
    delete_collection: 'Collection has been deleted successfully!',
    collection_created: 'Collection created successfully',
    delete_video: 'Your video has been deleted successfully!',
    clone_video: 'Your video has been cloned successfully!',
    reinvited: 'Invitation has been sent',
    transcript_download: 'Your transcript has been downloaded successfully',
    delete_customer: 'Customer has been deleted successfully!',
    invitation_sent: 'Invitation has been sent via email',
    upload_csv: `%{count} record(s) has been successfully inserted`
  }
};
